import React, {Component} from 'react';
import {Redirect} from 'react-router';
import {connect} from 'react-redux';
import * as Actions from '../actions';
import Settings from '../lib/settings';

class Article extends Component {

  constructor(props) {
    super(props);
    this.state = {

      article: "",
      articleName: "",
      ok: true,
      parsed: false

    };
    this.loadPage(this.props);
  }

  componentDidMount() {
  }

  loadPage(myProps) {

    //this.props.dispatch(Actions.loader(true));
    fetch('/api/articles/' + myProps.match.params.slug, Settings.fetchParams('GET')).then(res => res.json()).then(json => {
      this.props.dispatch(Actions.loader(false));
      if (json === null) {
        this.setState({ok: false});
      } else {
        this.setState({article: json.article, articleName: json.name, ok: true});
      }
    });
    window.scrollTo(0, this.props.menuPosition)


  }

  componentWillReceiveProps(nextProps) {

    this.loadPage(nextProps);
    this.setState({parsed: false});

  //  ReactDOM.findDOMNode(this.refs.hideUntil).style.opacity = 0;
  }

  render() {

    if (!this.state.ok) {
      return <Redirect to="/"/>;
    }

    const content = this.state.article;
    function createMarkup() {
      return {__html: content};
    };

    return (<div>
      <div className="productDetails">
        <div className="col100">
          <div className="articleWrapper">
          <h2>{this.state.articleName}</h2>
          <div className="articleText" dangerouslySetInnerHTML={createMarkup()}></div>
          </div>
        </div>
      </div>
    </div>);
  }
}
function mapStateToProps(state){
  return {
    admin: state.admin,
    menuPosition: state.menuPosition,
  };
}
export default connect(mapStateToProps)(Article);



// WEBPACK FOOTER //
// ./src/pages/Article.js